import { ofType } from "redux-observable";
import { map, mergeMap } from "rxjs/operators";
import { putJSON, postJSON, deleteJSON } from "../utils/ajaxUtil";
import {
  REQUESTED_CREATE_VERSION,
  REQUESTED_UPDATE_VERSION,
  REQUESTED_DELETE_VERSION,
  receiveCreateVersion,
  receiveUpdateVersion,
  receiveDeleteVersion,
} from "../redux/actions/versionAction";

export const createVersion = (action$) =>
  action$.pipe(
    ofType(REQUESTED_CREATE_VERSION),
    map((action) => action.payload.version),
    mergeMap((version) =>
      postJSON(`/versions/`, version).pipe(
        map((res) => receiveCreateVersion(res.data))
      )
    )
  );

export const updateVersion = (action$) =>
  action$.pipe(
    ofType(REQUESTED_UPDATE_VERSION),
    map((action) => action.payload.version),
    mergeMap((version) =>
      putJSON(`/versions/${version.id}/`, version).pipe(
        map((res) => receiveUpdateVersion(res.data))
      )
    )
  );

export const deleteVersion = (action$) =>
  action$.pipe(
    ofType(REQUESTED_DELETE_VERSION),
    map((action) => action.payload.version),
    mergeMap((version) =>
      deleteJSON(`/versions/${version.id}/`).pipe(
        map((res) => receiveDeleteVersion(res.data))
      )
    )
  );
